// Client HTTP : Bearer token + gestion de l'expiration de session.
const TOKEN_KEY = "predicty_token";

export const auth = {
  get token() { return localStorage.getItem(TOKEN_KEY); },
  set(token) { localStorage.setItem(TOKEN_KEY, token); },
  clear() { localStorage.removeItem(TOKEN_KEY); },
};

export async function api(path, { method = "GET", body } = {}) {
  const headers = { "Content-Type": "application/json" };
  if (auth.token) headers.Authorization = "Bearer " + auth.token;
  const res = await fetch("/api" + path, {
    method, headers, body: body ? JSON.stringify(body) : undefined,
  });
  if (res.status === 401) {
    auth.clear();
    window.dispatchEvent(new Event("predicty-logout"));
    throw new Error("Session expirée");
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    // Le corps de la réponse reste accessible (ex. liste des prérequis manquants d'arm-live).
    const err = new Error(data.error || "Erreur " + res.status);
    err.status = res.status; err.data = data;
    throw err;
  }
  return data;
}
